import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=3fc6ba2c&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=js&"
export * from "./GroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=3fc6ba2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6ba2c",
  null
  
)

export default component.exports